import canRunAutofillOnRow from '../../../helpers/canRunAutofillOnRow';
import evaluateListFilter from "./evaluateListFilter";

const getFilteredListIndex = (
  item: Record<string, unknown>,
  expression: string,
  checkfield: string,
  list: Array<Record<string, unknown>>,
): number | null => {
  if (!canRunAutofillOnRow(item)) {
    return null;
  }

  const filteredList = list.filter((element) => (
    canRunAutofillOnRow(element)
    && evaluateListFilter(element, expression, checkfield)
  ));

  const indexOfItem = filteredList.indexOf(item); // -1 if not found
  return indexOfItem < 0 ? null : indexOfItem + 1;
};
export default getFilteredListIndex;
